import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-note-sujet-alert-list',
  templateUrl: './note-sujet-alert-list.component.html',
  styleUrls: ['./note-sujet-alert-list.component.scss']
})
export class NoteSujetAlertListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
